















































































































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { Mutation, State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { Component } from 'vue-property-decorator';
import { MswAppTitle } from '@/shared/msw-app-title';
import {
ColumnSortRequestData,
  SortedColumnInfo,
  SwTable, TableColumnConfig, TableEntry,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import {
  SwExpandableTextfield,
  SwTextfield,
} from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
// import { TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { CreateElement, VNode } from 'vue';
import DownloadsTable from './components/download-table.component.vue';
import { InfoState, SetHelpContentIdPayload } from '@/core';
import { SwFilterInput } from '@/shared/sw-filter-input';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
const cssPrefix = 'freeDownloads';

@Component({
  components: {
    ...UUIFComponents,
    MswAppTitle,
    SwTable,
    SwDropMenu,
    SwIconButton,
    SwIcon,
    SwExpandableTextfield,
    SwTextfield,
    SwSelect,
    DownloadsTable,
    SwFilterInput,
  },
})
export default class FreeDownloads extends SwExtendedVue {
  @State((state: RootStoreState) => state.CoreStoreModule.loggedIn)
  loggedIn: boolean;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  cssPrefix = cssPrefix;
  menuOpened: boolean = false;
  textExpanded: boolean = false;
  tableData: any[] = []; // For table data
  tempTableData: any[] = []; // For duplicate table data
  downloadsRequestData = {
    category: 'LATEST',
    productType: '9683',
    swLangCode: 'EN',
    fileType: ['Firmware'], // ['Firmware", 'DOC']
    releaseTypeList: [{ releaseType: 'ALL' }],
    keyWord: '',
    previousVersions: false,
    isFileTypeChange: false,
    username: this.$store.getters.getUserId || 'anonymous',
  };
  filtersRequestData = {
    language: 'EN',
    fileType: 'Firmware',
    username: this.$store.getters.getUserId || 'anonymous',
  };
  sortedColumns: SortedColumnInfo[] = [];
  currlanguage: string = '0';
  currProductType: string = '0';
  currReleaseType: string = '0';
  currFileType: string = '0';
  currCategory: string = '0';
  languageList: SelectOption[] = [];
  productTypeList: SelectOption[] = [];
  releaseTypeList: SelectOption[] = [];
  fileTypeList: SelectOption[] = [
    {
      id: '0',
      label: this.$t('products.firmware')
      .toString(),
      value: 'Firmware',
    },
    {
      id: '1',
      label: this.$t('downloadcenter.documentation')
      .toString(),
      value: 'DOC',
    },
  ];
  categoryList: SelectOption[] = [
    {
      id: '0',
      label: this.$t('downloadcenter.latestVersion')
      .toString(),
      value: 'LATEST',
    },
    {
      id: '1',
      label: this.$t('downloadcenter.allVersion')
      .toString(),
      value: 'ALL',
    },
  ];

  filterSearch: string = '';
  searchInputChips: any[] = [];
  filterSearchConfig: any = {
    isEnableFilterSearch: false,
    filterSearchKey:'',
    filterSearchOption:'',
    filterSearchLabel:'',
  };
  globalSearchValue : string = '';
  columnSearchValue : string = '';
  filterColumnKey: string = '';
  filterColumnValue: string = '';

  get tableColConfigArr(): TableColumnConfig[] {
    return [
      {
        key: '_key',
        dataKey: '_key',
        title: '#',
        width: 80,
      },
      {
        key: 'expand',
        type: 'expand',
        // tslint:disable-next-line
        render: (h: CreateElement, data: any): VNode => {
          return (
            <div style="margin: 2rem">
              <DownloadsTable softwareList={data.entry.softwareList} title={data.entry.name} releaseType={data.entry.releaseType}  firmwareEndDate={data.entry.firmwareEndDate}/>
            </div>
            ) as VNode;
        },
      },
      {
        key: 'name',
        dataKey: 'name',
        sorter: true,
        title:  this.$t('products.name')
        .toString(),
      },
      {
        key: 'releaseType',
        dataKey: 'releaseType',
        sorter: true,
        title: this.$t('downloadcenter.releaseType')
        .toString(),
      },
      {
        key: 'version',
        dataKey: 'version',
        sorter: true,
        title: this.$t('products.version')
        .toString(),
      },
      {
        key: 'releaseDate',
        dataKey: 'releaseDate',
        title: this.$t('products.release_date')
        .toString(),
        sorter: (a: TableEntry, b: TableEntry) => {
          const aDate: any = new Date(a.releaseDate);
          const bDate: any = new Date(b.releaseDate);
          return aDate - bDate;
        },
      },
      {
        key: 'firmwareEndDate',
        dataKey: 'firmwareEndDate',
        sorter: true,
        /* tslint:disable-next-line */
        title: (h: CreateElement): VNode => {
          return (
            <div style="display:flex;align-items:center;">
              <span style="margin-right:1rem;"> { this.$t('downloadcenter.eosDate') } </span>
              <div style="cursor:pointer;">
                {/* tslint:disable-next-line */}
                <SwIcon name="informational" props-size={15} color="#47afe2" v-tooltip={{ content: this.$t('common.eosInfo'), compact: true, placement: 'bottom' }} ></SwIcon>
              </div>
            </div>
          ) as VNode;
        },
        width: 150,
        scalable : true,
        /* tslint:disable-next-line */
        render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
          return (
            <span style={ data.entry.firmwareStatus === 'ACTIVE' ? '' : 'color: red' }> {data.entry.firmwareEndDate} </span>
          ) as VNode;
        },
      },
      {
        key: 'fileType',
        dataKey: 'fileType',
        sorter: true,
        title: this.$t('common.fileType')
        .toString(),
      },
      {
        key: 'languageCode',
        dataKey: 'languageCode',
        sorter: true,
        title: this.$t('downloadcenter.language')
        .toString(),
      },
    ];
  }

   // For Filter menu items
  get filterItems(): DropMenuItem[] {
    return [
      {
        id: 'name',
        content: this.$t('products.name')
        .toString(),
      },
      {
        id: 'releaseType',
        content: this.$t('downloadcenter.releaseType')
        .toString(),
      },
      {
        id: 'version',
        content: this.$t('products.version')
        .toString(),
      },
      {
        id: 'releaseDate',
        content: this.$t('products.release_date')
        .toString(),
      },
      {
        id: 'firmwareEndDate',
        content: this.$t('downloadcenter.eosDate')
        .toString(),
      },
      {
        id: 'fileType',
        content: this.$t('common.fileType')
        .toString(),
      },
      {
        id: 'languageCode',
        content: this.$t('downloadcenter.language')
        .toString(),
      },
    ];
  }

  // For title of the page
  get getHeaderConfig() {
    return {
      pageTitle: this.$t('downloadcenter.freeDownloads')
      .toString(),
      pageParentName: '',
      isFetchFromProps: true,
      isShowDashboardIcon: this.loggedIn ? true : false,
      isShowSlash: this.loggedIn ? true : false,
      isShowParent: this.loggedIn ? true : false,
    };
  }

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  // Filter Implementation starts
  handleSearchFilter() {
    this.applyAllFilters();
  }

  removeInputChip(index: any) {
    this.searchInputChips.splice(index, 1);
    this.applyAllFilters();
  }

  addFilterKey(event: any) {
    if (event.code === 'Enter' && this.filterSearchConfig.filterSearchKey !== '') {
      this.searchInputChips.push({ value: this.filterSearchConfig.filterSearchKey.trim(), column: this.filterSearchConfig.filterSearchOption });
      this.applyAllFilters();
      this.filterSearchConfig.filterSearchKey = '';
      this.filterSearchConfig.filterSearchLabel = '';
      this.filterSearchConfig.isEnableFilterSearch = false;
    }
  }

  applyAllFilters() {
    const data: any[] = [...this.tempTableData];
    let filteredData : any[] = [];
    this.$store.commit('startLoading');
    if (this.globalSearchValue) {
      this.filterItems.forEach((column: any) => {
        filteredData.push(...data.filter((element: any) => {
          return element[column.id].indexOf(this.globalSearchValue) > -1;
        }));
      });
    } else {
      if (this.searchInputChips.length === 0) {
        this.tableData = [...data];
        this.$store.commit('stopLoading');
        return;
      }
      filteredData = data.filter((item) => {
        for (const filter of this.searchInputChips) {
          if (item[filter.column] !== filter.value) {
            return false;
          }
        }
        return true;
      });
    }
    this.tableData = [...filteredData];
    this.$store.commit('stopLoading');
  }

  onRemoveAllFilters() {
    this.globalSearchValue = '';
    this.columnSearchValue = '';
    this.filterSearchConfig = {
      isEnableFilterSearch: false,
      filterSearchKey:'',
      filterSearchOption:'',
      filterSearchLabel:'',
    };
    this.searchInputChips = [];
    this.applyAllFilters();
  }

  onSelectMultiItem(type: any) {
    this.menuOpened = !this.menuOpened;
    this.globalSearchValue = '';
    this.focusInput();
    const isExistingChip = this.searchInputChips?.find((el: any) => el.column === type);
    if (!isExistingChip) {
      this.filterSearchConfig.isEnableFilterSearch = true;
      this.filterSearchConfig.filterSearchOption = type;
      this.filterSearchConfig.filterSearchLabel = this.filterItems.filter(ele => ele.id.toString() === type)[0].content;
    }
  }

  focusInput() {
    setTimeout(() => {
      const filterInput = document.getElementById('filterWrapper') as HTMLElement;
      filterInput?.children[0]
        .getElementsByTagName('input')[0]
        .focus();
    },         200);
  }
  // Filter Implementation ends

  // Methods for sw-selects
  onChangeLanguage(optionId: string) {
    const sellang:any = this.languageList.filter((language:any) => { if (language.id === optionId) return language; });
    this.downloadsRequestData.swLangCode = sellang[0].value;
    this.filtersRequestData.language = sellang[0].value;
    // this.fetchFiltersList();
    this.fetchDownloadAndFiltersList();
  }

  // tslint:disable-next-line:no-unused
  onChangeProductType(optionId: string) {
    const selprodtyp:any = this.productTypeList.filter((prodType:any) => { if (prodType.id === optionId) return prodType; });
    this.downloadsRequestData.productType = selprodtyp[0].value;
    this.fetchFreeDownloadsList();
  }

  // tslint:disable-next-line:no-unused
  onChangeReleaseType(optionId: string) {
    const selreltype:any = this.releaseTypeList.filter((releType:any) => { if (releType.id === optionId) return releType; });
    this.downloadsRequestData.releaseTypeList[0].releaseType = selreltype[0].value;
    this.fetchFreeDownloadsList();
  }

  // tslint:disable-next-line:no-unused
  onChangeFileType(optionId: string) {
    const selfiletype:any = this.fileTypeList.filter((fileType:any) => { if (fileType.id === optionId) return fileType; });
    this.downloadsRequestData.fileType[0] = selfiletype[0].value;
    this.filtersRequestData.fileType = selfiletype[0].value;
    this.downloadsRequestData.isFileTypeChange = true;
    // this.fetchFiltersList();
    // this.fetchDownloadAndFiltersList();
    this.fetchFiltersList('callDownloadList');
  }

  onChangeCategory(optionId: string) {
    const selcateg:any = this.categoryList.filter((category:any) => { if (category.id === optionId) return category; });
    this.downloadsRequestData.category = selcateg[0].value;
    this.fetchFreeDownloadsList();
  }

  // Data fetch for downloads and filters
  fetchFreeDownloadsList() {
    this.onRemoveAllFilters();
    this.textExpanded = false;
    this.tableData = [];
    return new Promise((resolve) => {
      console.warn(this.downloadsRequestData);
      this.$store.dispatch('FreeDownloadsStoreModule/getFreeApplicableDownloads', this.downloadsRequestData)
      .then((resp: any) => {
        if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:SUCCESS') {
          const result = resp.content.userDownloads || [];
          if (result.length > 0) {
            // const downloadList: any[] = [];
            this.tableData = [];
            result.forEach((userDownload:any) => {
              if (userDownload.applicableDownloads && userDownload.applicableDownloads.length > 0) {
                userDownload.applicableDownloads.forEach((dnldList:any) => {
                  dnldList.softwareList.map((slist:any) => {
                    slist.free = true;
                    slist.firmwareEndDate = dnldList.firmwareEndDate;
                    slist.firmwareStatus = dnldList.firmwareStatus;
                  });
                  this.tableData.push(dnldList);
                });
                // downloadList = downloadList.concat(userDownload.applicableDownloads);
              }
            });
            this.tableData.map((item: any, index: number) => {
              item['_key'] = index + 1;
            });
            this.tempTableData = this.tableData;
          } else {
            this.tableData = [];
            this.tempTableData = [];
          }
        } else {
          this.tableData = [];
          this.tempTableData = [];
          this.showMessage('failed', resp.msgDesc);
        }
        resolve(true);
      })
      .catch(() => {
        resolve(false);
        this.$store.commit('stopLoading');
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
    });
  }

  redirectToFirmware() {
    window.open('https://www.sonicwall.com/support/product-lifecycle-tables/#software-and-firmware-release-model', '_blank');
  }

  fetchFiltersList(val: string = '') {
    return new Promise((resolve) => {
      this.$store.dispatch('FreeDownloadsStoreModule/getFreeDownLoadCenterFilters', this.filtersRequestData)
      .then((resp: any) => {
        if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:SUCCESS') {
          const result = resp.content;
          if (result.languageList && result.languageList.length > 0) {
            const resLangList = result.languageList;
            this.languageList = resLangList.map((element:any, index:any) => {
              return { id: `${index}`, label: element.Language, value: element.LanguageCode };
            });
            this.downloadsRequestData.swLangCode = resLangList[0].LanguageCode;
          }
          if (result.productTypeList && result.productTypeList.length > 0) {
            const resProdTypeList = result.productTypeList;
            this.productTypeList = resProdTypeList.map((element:any, index:any) => {
              return { id: `${index}`, label: element.productTypeName, value: element.productGroupID };
            });
            this.downloadsRequestData.productType = resProdTypeList[0]['productGroupID'];
            if (val === 'callDownloadList') this.fetchFreeDownloadsList();
          }
          if (result.releaseTypeList && result.releaseTypeList.length > 0) {
            const resRelTypeList = result.releaseTypeList;
            resRelTypeList.unshift({ releaseType: 'ALL' });
            this.releaseTypeList = resRelTypeList.map((element:any, index:any) => {
              return { id: `${index}`, label: element.releaseType, value: element.releaseType };
            });
            this.downloadsRequestData.releaseTypeList[0].releaseType = resRelTypeList[0].releaseType;
          }
          // this.fetchFreeDownloadsList();
        } else {
          this.showMessage('failed', resp.msgDesc);
        }
        resolve(true);
      })
      .catch(() => {
        resolve(false);
        this.$store.commit('stopLoading');
      });
    });
  }

  fetchDownloadAndFiltersList() {
    const getFiltersList = this.fetchFiltersList();
    const getDownloadsList = this.fetchFreeDownloadsList();
    this.$store.commit('startLoading');
    Promise.all([getFiltersList, getDownloadsList])
    .then(() => {
      this.$store.commit('stopLoading');
    });
  }

  mounted() {
    this.setHelpId('freedownloads');
    this.fetchDownloadAndFiltersList();
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
  }

  destroyed() {
    this.setHelpId('default');
  }

  // For toaster message
  showMessage(infoType: string, infoMsg: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }

  public focus(event: any) {
    console.warn(event);
    console.warn(((this.$refs.filterLabel as SwTextfield).$refs.input as HTMLElement));
    ((this.$refs.filterLabel as SwTextfield).$refs.input as HTMLElement).focus();
  }
}
